<template>
  <div class="reports-editor-view reports-typography">
    <ReportModeSwitcher v-model="activeMode" />

    <AnalyticsEditorView
      v-if="activeMode === 'analytics'"
      :report-id="analyticsReportId"
      :draft-id="draftId"
      :tab-id="tabId"
    />
    <WorkPermissionsEditorView
      v-else
      :report-id="workPermissionsReportId"
    />
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import ReportModeSwitcher from '@/components/reports/ReportModeSwitcher.vue';
import '@/assets/styles/payment-lists.css';
import AnalyticsEditorView from '@/views/analytics/AnalyticsEditorView.vue';
import WorkPermissionsEditorView from '@/views/reports/WorkPermissionsEditorView.vue';

const props = defineProps({
  reportId: {
    type: [String, Number],
    default: null,
  },
  reportType: {
    type: String,
    default: 'analytics',
  },
  draftId: {
    type: [String, Number],
    default: null,
  },
  tabId: {
    type: String,
    default: null,
  },
});

const normalizeMode = (value) =>
  value === 'work-permissions' ? 'work-permissions' : 'analytics';

const activeMode = ref(normalizeMode(props.reportType));

watch(
  () => props.reportType,
  (next) => {
    activeMode.value = normalizeMode(next);
  },
);

const analyticsReportId = computed(() =>
  activeMode.value === 'analytics' && normalizeMode(props.reportType) === 'analytics'
    ? props.reportId
    : null,
);

const workPermissionsReportId = computed(() =>
  activeMode.value === 'work-permissions' && normalizeMode(props.reportType) === 'work-permissions'
    ? props.reportId
    : null,
);
</script>

<style scoped>
/* The page frame: the report views inside it keep no padding of their own. */
.reports-editor-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: var(--noc-background);
  color: var(--text-color);
  font: var(--ap-type-body);
}

.reports-editor-view > :deep(.analytics-editor),
.reports-editor-view > :deep(.work-permissions-editor) {
  padding: 0;
}

@media (max-width: 760px) {
  .reports-editor-view {
    padding: 16px;
  }
}
</style>
